import React from 'react';

import css from './ImagePreview.module.css';
import { limitText } from '../LatestNewsSection/utils';

const ImagePreview = (props) => {
  const {
    file,
  } = props;

  return (
    <>
      <a className={css.link} href={file?.href} target="_blank">
        <img 
        className={css.imageItem} 
        src={file?.href} 
        />
        <span>{limitText(file?.description || file?.name , 15)}</span>
      </a>
    </>
  );
};

export default ImagePreview;
